export class UpdateWorkspaceStorageAccessConfigurationInputGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allowedCredentialProfiles",
            "baseName": "allowedCredentialProfiles",
            "type": "Array<WorkspaceStorageAllowedCredentialsProfileInput>",
            "format": ""
        },
        {
            "name": "allowedPrincipals",
            "baseName": "allowedPrincipals",
            "type": "Array<WorkspaceAllowedPrincipalInput>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceStorageAccessConfigurationInputGcp.attributeTypeMap;
    }
    constructor() {
    }
}
